import { Component, Input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { SafeHtmlPipe } from '@sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'sb-formatted-text',
    templateUrl: './formatted-text.component.html',
    styleUrls: ['./formatted-text.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [SafeHtmlPipe, FormsModule],
})
export class FormattedTextComponent {
    @Input() formField: Field | ClientField;
}
